var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:`c-button c-button-${_vm.type} ${_vm.styles} fb fb-main-center fb-cross-center ${
      _vm.disabled ? 'button-disabled' : ''
    }`,on:{"click":_vm.handlerClick}},[_c('span',[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }